import * as THREE from "three";

const MAX_SCORCHES = 25;

const mat = new THREE.MeshStandardMaterial({
  color: 0x0a0a0a,
  roughness: 1,
  transparent: true,
  opacity: 0.72,
  depthWrite: false,
  side: THREE.DoubleSide,
});

export class ScorchManager {
  private readonly pool: THREE.Mesh[] = [];
  private head = 0;

  constructor(private readonly scene: THREE.Scene) {
    for (let i = 0; i < MAX_SCORCHES; i++) {
      const m = new THREE.Mesh(new THREE.CircleGeometry(1, 12), mat);
      m.rotation.x = -Math.PI / 2;
      m.visible = false;
      m.userData["isVFX"] = true;
      scene.add(m);
      this.pool.push(m);
    }
  }

  spawn(point: THREE.Vector3, radius: number): void {
    const m = this.pool[this.head % MAX_SCORCHES]!;
    this.head++;
    const r = radius * (0.6 + Math.random() * 0.5);
    m.scale.set(r * (1.1 + Math.random() * 0.35), r * (0.8 + Math.random() * 0.3), r);
    m.position.set(point.x, point.y + 0.08, point.z);
    m.rotation.z = Math.random() * Math.PI * 2;
    m.visible = true;
  }

  dispose(): void {
    for (const m of this.pool) this.scene.remove(m);
  }
}
